
import React, {  } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
import dj1 from "../../static/images/dj1.jpg"
import dj2 from "../../static/images/dj2.png"
import dj3 from "../../static/images/dj3.png"
import dj4 from "../../static/images/dj4.png"
import iso from "../../static/images/ios.png"
import about4 from "../../static/images/about4.jpg"
export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'0'} />
        <AboutTitle name={'关于我们'} english={'ABOUT US'}  />
        <div className='aboutCoctent'>
        <p>深圳市远东数智采技术服务有限公司（以下简称公司）是一家专注于为招标采购交易（公共采购交易）与供应链领域提供全过程全生命周期数智化解决方案、垂类智能体系统（Agent System）、数据治理、咨询服务以及运维运营服务。公司现已获得发明专利和软件著作知识产权达80+件，获得电子招投标系统三星认证、网络安全三级等保认证、ISO质量管理体系认证。</p>
        <p>顺应国家倡导的“互联网+招投标”的全新业务形态，公司基于国产信创产品技术底座，经年组织“技术+行业业务”团队研发“AiPRT公共资源数智采系统” 原研原生产品；作为用友ISV伙伴产品，与用友等全系列产品互联互通、融合开发与技术服务伙伴体系、共销共营市场渠道体系；作为金融ISV伙伴产品，与中国民生银行、微众银行、深圳高新投等金融服务互联互通；作为招标采购交易（公共资源交易）领域的数智化产品和运营服务方，在“技术开发、实施部署、业务管理、互联互通、运维运营”上构建招标采购交易活动全生命周期数智化体系，努力推进实现“自主信创技术+垂类业务流程+行业知识库+领域数据治理+垂类智能体系统+金融服务”的愿景。</p>
        <p>公司拥有一支从业公共采购、企业招采、供应链管理和咨询多年的专业团队，凝聚了一批行业资深专家，成为中国物流与采购协会公共采购分会理事单位、中国招标投标协会招标采购数字化专业委员会单位，与用友合作的原生态产品开发的“公共资源交易行业垂类大模型”在2024北京人工智能生态大会上入选北京首批“人工智能+”应用场景十佳案例，原生 “政府采购一体化交易云平台系统” 服务方案获中国政府采购网推荐为“政府采购项目电子化交易系统”；在用友第七届企业数智化创新应用开发大赛中荣获大中型企业赛道“最佳行业方案奖”。</p>
        <p>我们致力于：</p>
        <p><strong>为各类公共采购人提供云订阅、专属云和本地部署的数智产品和服务方案；</strong></p>
        <p><strong>为招标采购人提供业务实施支持、专业咨询服务、应用场景协同与集成。</strong></p>
        </div>
        <div className='companyTv'>
          <div className='companyTv-right'>
          <dl>
              <dt><img src={dj4} /></dt>
              <dd>三星产品认证证书</dd>
            </dl>
            <dl>
              <dt><img src={dj1} /></dt>
              <dd>网络安全三级等保证</dd>
            </dl>
            <dl>
              <dt><img src={iso} /></dt>
              <dd>IOS9001质量管理体系认证证书</dd>
            </dl>
            <dl>
              <dt><img src={dj2} /></dt>
              <dd>招标采购数字化专业委员会</dd>
            </dl>
            {/* <dl>
              <dt><img src={dj3} /></dt>
              <dd>AiPRT商标注册证</dd>
            </dl> */}
            <dl>
              <dt><img src={about4} /></dt>
              <dd>广东省政府采购协会会员证书</dd>
            </dl>
          </div>
        </div>
      </PageBox>
    </>
  );
}
